
function devtricker_process_activateAllBootstrapTooltip() {

    //Activate and customize the tooltip click
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');

    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => {
        let tooltip = new bootstrap.Tooltip(tooltipTriggerEl);

        tooltipTriggerEl.addEventListener('click', function () {
            tooltip.hide();
        });

        return tooltip;
    });
}


document.addEventListener('DOMContentLoaded', function() {
    var tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');

    tooltipElements.forEach(function(element) {
        var tooltip = new bootstrap.Tooltip(element);

        element.addEventListener('click', function() {
            setTimeout(() => {
                tooltip.hide();
            }, 100);
        });
    });
});